import { Component, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';

import { Events, GridApi, IStatusPanelParams } from 'ag-grid-community';
import { GlobalsService } from '../../services/globals.service';
import { AgrFuncs, PageDirection, StatusBarSummaryData } from './datagrid.component';

@Component({
    selector: 'vias-datagrid-statusbar-pagination',
    template: `<div class="ag-status-name-value ag-status-panel ag-status-panel-total-and-filtered-row-count">{{summaryValue}}</div>`,
})
export class StatusBarTotalsComponent {
    private params: IStatusPanelParams;
    private gridApi: GridApi;
    // nav disabled   ilk   once  sonra  son // PageDirection
    nav: boolean[] = [];

    public summaryValue: string = '';
    public pageChange: EventEmitter<PageDirection> = new EventEmitter();
    constructor(protected globalService: GlobalsService){}

    agInit(params: IStatusPanelParams): void {
        this.params = params;
        this.params.api.addEventListener(Events.EVENT_ROW_DATA_CHANGED, this.onModelChange.bind(this));
        this.params.api.addEventListener('gridReady', this.onGridReady.bind(this));
        // this.params.api.addEventListener('paginationChanged', this.onPaginationChanged.bind(this));
    }
    onGridReady($event): void {
        console.log($event);
    }
    onModelChange(params: IStatusPanelParams): void {
        this.params = params;
        let sumString = '';
        let valueRecieved = false;
        if (this.params.api['statusBarService'].allComponents.StatusPanelTotals._params.summaryData !== undefined) {
            // tslint:disable-next-line: max-line-length
            const x: StatusBarSummaryData[] = this.params.api['statusBarService'].allComponents.StatusPanelTotals._params.summaryData;
            x.forEach(sD => {
                // sumString += '<div class="ag-status-name-value"> ';
                // sumString += ' <span ref="eLabel">';
                sumString += sD.title + ' : '; // </span>:&nbsp;';
                // sumString += '<span ref="eValue" class="ag-status-name-value-value">';
                let sumTotal = 0;
                let rowCount = 0;
                this.params.api.forEachNode((rowNode) => {
                    if (rowNode !== undefined) {
                        valueRecieved = true;
                        if (rowNode.data[sD.field] !== undefined) {
                            let rowTotal = 0;
                            if (sD.sumTotalFunction !== undefined){
                                rowTotal = sD.sumTotalFunction(rowNode.data);
                            }else{
                                rowTotal = rowNode.data[sD.field] * 1;
                            }
                            sumTotal += rowTotal;
                            rowCount++;
                        }
                    }
                });
                if (rowCount > 0) {
                    switch (sD.aggFunc) {
                        case AgrFuncs.count:
                            sumString += rowCount;
                            break;
                        case AgrFuncs.avrg:
                            sumString += this.globalService.numberFormatter(sumTotal / rowCount);
                            break;
                        case AgrFuncs.sum:
                        default:
                            sumString += this.globalService.numberFormatter(sumTotal);
                            break;
                    }
                    sumString += ' ';
                    if (sD.unitName.length > 0) {
                        sumString += sD.unitName;
                    }
                }
                sumString += ' ';
                // sumString += '</span></div>';
            });
        }
        if (valueRecieved) {
            this.summaryValue = sumString;
        }
    }
}

